function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 30c-1.6 0-3.1-.2-4.5-.7V22h-8v1.3C.9 20.8 0 17.9 0 15 0 7.9 4.9 2 11.5.4v2.1h9V1C26.1 3.2 30 8.6 30 15c0 8.3-6.7 15-15 15z",
  fill: "#beb0f4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5 15h-8v11H11v-.1 3.6c-4-1.1-7.3-3.8-9.3-7.5 1.3-4.1 5-6.8 9.3-7V.5c1.3-.3 2.7-.5 4-.5 2.1 0 4.2.4 6 1.2v5c0 3.8 2.8 6.8 6.4 7.3.6.1 1.1.8 1.1 1.5z",
  fill: "#7356b6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5 15c0 .7-.5 1.3-1.1 1.4-3.6.6-6.4 3.6-6.4 7.3V27c-1.9.9-3.9 1.4-6 1.4-1.4 0-2.7-.2-4-.6V25c0-4.4 3.6-8.1 7.8-8.6.7-.1 1.2-.7 1.2-1.4h8.5zm-26-5.2C4.1 6.1 7.2 3.3 11 2.1V5c0 4.4 3.6 8 7.8 8.6.7.1 1.2.7 1.2 1.4h-8.8c-3.7 0-7-2.1-8.7-5.2z",
  fill: "#FFF"
});

function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMHB4IiBoZWlnaHQ9IjMwcHgiPjxwYXRoIGQ9Ik0xNSAzMGMtMS42IDAtMy4xLS4yLTQuNS0uN1YyMmgtOHYxLjNDLjkgMjAuOCAwIDE3LjkgMCAxNSAwIDcuOSA0LjkgMiAxMS41LjR2Mi4xaDlWMUMyNi4xIDMuMiAzMCA4LjYgMzAgMTVjMCA4LjMtNi43IDE1LTE1IDE1eiIgZmlsbD0iI2JlYjBmNCIvPjxwYXRoIGQ9Ik0yOC41IDE1aC04djExSDExdi0uMSAzLjZjLTQtMS4xLTcuMy0zLjgtOS4zLTcuNSAxLjMtNC4xIDUtNi44IDkuMy03Vi41YzEuMy0uMyAyLjctLjUgNC0uNSAyLjEgMCA0LjIuNCA2IDEuMnY1YzAgMy44IDIuOCA2LjggNi40IDcuMy42LjEgMS4xLjggMS4xIDEuNXoiIGZpbGw9IiM3MzU2YjYiLz48cGF0aCBkPSJNMjguNSAxNWMwIC43LS41IDEuMy0xLjEgMS40LTMuNi42LTYuNCAzLjYtNi40IDcuM1YyN2MtMS45LjktMy45IDEuNC02IDEuNC0xLjQgMC0yLjctLjItNC0uNlYyNWMwLTQuNCAzLjYtOC4xIDcuOC04LjYuNy0uMSAxLjItLjcgMS4yLTEuNGg4LjV6bS0yNi01LjJDNC4xIDYuMSA3LjIgMy4zIDExIDIuMVY1YzAgNC40IDMuNiA4IDcuOCA4LjYuNy4xIDEuMi43IDEuMiAxLjRoLTguOGMtMy43IDAtNy0yLjEtOC43LTUuMnoiIGZpbGw9IiNGRkYiLz48L3N2Zz4=";
export { SvgIcon as ReactComponent };